import React from 'react'
import { connect } from 'react-redux'
import { withStyles, Typography } from '@material-ui/core'
import classNames from 'classnames'
import language from 'utils/vast-languagepack'

const Heading = withStyles((theme) => ({
	heading: {
		fontSize: theme.typography.pxToRem(19),
		fontWeight: theme.typography.fontWeightBold,
		marginRight: 7,
	},
	color: { color: '#fff' },
}))(({ title, classes }) => (
	<Typography className={classNames(classes.heading, classes.color)}>
		{title}
	</Typography>
))

const TaskHeading = connect(
	(state) => ({
		title:
			state.view.stepper.campaign === 2
				? language.campaign.add.campaignScheduleTaskHeading
				: language.campaign.add.campaignAutoTaskHeading,
	}),
	null,
)(Heading)

export default ({ title }) =>
	title === 'TASKS' ? <TaskHeading /> : <Heading title={title} />
